import React from "react";

type Props = {
  className?: string;
};
export const BulbIcon: React.FC<Props> = ({ className }) => {
  return (
    <svg className={className} viewBox="0 0 11 15" fill="none">
      <path d="M5.62881 0.742984C2.70123 0.742984 0.320419 3.12379 0.320419 6.05138C0.320419 7.7275 1.12464 9.29216 2.44378 10.2821V11.8906C2.44378 13.3544 3.63418 14.5448 5.09797 14.5448H6.15965C7.62344 14.5448 8.81385 13.3544 8.81385 11.8906V10.2834C10.133 9.29342 10.9372 7.72747 10.9372 6.05134C10.9372 3.12376 8.55639 0.742984 5.62881 0.742984ZM6.69049 11.8904C6.69049 12.1837 6.45294 12.4213 6.15965 12.4213H5.09797C4.80468 12.4213 4.56713 12.1837 4.56713 11.8904V10.8288H6.69049V11.8904ZM7.37129 8.7054H3.88627C2.99446 8.12547 2.44371 7.12617 2.44371 6.05121C2.44371 4.29412 3.87166 2.86617 5.62874 2.86617C7.38583 2.86617 8.81378 4.29412 8.81378 6.05121C8.81378 7.12617 8.2631 8.12547 7.37129 8.7054Z" />
    </svg>
  );
};
